import React from 'react';

import { Flex, Empty, Typography } from '@app/ui';
import { useTranslation } from 'react-i18next';

interface EmptyProps {
    text?: string;
}

const EmptyComponent: React.FC<EmptyProps> = ({ text }: EmptyProps) => {
    const { t } = useTranslation('common');
    const displayText = text ?? t('noDataAvailable');
    return (
        <Flex
            style={{
                width: '100%',
            }}
            justify="center"
            align="center"
        >
            <Flex
                justify="center"
                align="center"
                vertical
                style={{
                    boxShadow: '4px 4px 8px 2px rgba(0, 0, 0, 0.25)',
                    height: 'fit-content',
                    margin: 12,
                    borderRadius: 4,
                    padding: 12,
                    maxWidth: 200,
                }}
            >
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    styles={{
                        image: {
                            transform: 'scale(2)',
                            width: 200,
                        },
                    }}
                    description={false}
                />
                <Typography.Text>{displayText}</Typography.Text>
            </Flex>
        </Flex>
    );
};

export default EmptyComponent;
